import styled from 'styled-components/macro'
import { Card, Page } from 'styles'

export const KycErrorCard = styled(Card)`
  position: relative;

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
export const KycErrorStyled = styled(Page)`
  width: 100%;
  background-image: url('/images/bg-shapes.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
`

export const KycErrorTitle = styled.h1`
  font-family: 'Nizzoli';
  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;

  @media (max-width: 800px) {
    padding: 0;
  }
`

export const KycErrorTxt = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
`
export const KycErrorLink = styled.a`
  font-weight: bold;
`
